import DisputeEvidence from 'src/models/dispute/DisputeEvidence'
import Model, { encoders, IsoDateTime, MODEL_LEVEL } from 'src/models/model'

export default class Dispute extends Model {
  static name = 'Dispute'

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Financial]

  static define () {
    this.fields = {
      id: {
        type: String
      },
      amount: {
        type: Number,
        encode: encoders.cents,
        output: true,
        default: null
      },
      netAmount: {
        type: Number,
        encode: encoders.cents,
        output: true,
        default: null
      },
      createdAt: {
        type: IsoDateTime,
        output: true,
        default: null
      },
      reason: {
        type: String,
        default: null,
        output: true
      },
      status: {
        type: String,
        default: null,
        output: true
      },
      fee: {
        type: Number,
        encode: encoders.cents,
        output: true,
        default: null
      },
      evidenceDueBy: {
        type: IsoDateTime,
        output: true,
        default: null
      },
      hasEvidence: {
        type: Boolean,
        output: true,
        default: false
      },
      submissionCount: {
        type: Number,
        output: true,
        default: null
      },
      evidence: {
        type: DisputeEvidence,
        default: null,
        encode: encoders.hasOne,
        reference: false
      }
    }
  }
}
